import { Vue, Component, Prop } from 'vue-property-decorator';
import { eventBus } from '@/utils/EventBus';
import * as math from 'mathjs';

@Component({})
export default class ComponentController extends Vue {

  @Prop({ required: true, type: Boolean })
  private isForEnglishPaper!: boolean;
  @Prop({ required: true, type: Number })
  private numComponents!: number;
  @Prop({ required: true, type: Number })
  private readonly minNumComponents!: number;
  @Prop({ required: true, type: Number })
  private readonly maxNumComponents!: number;
  @Prop({ required: true, type: Number })
  private wardCutoff!: number;
  @Prop({ required: true, type: Number })
  private readonly minWardCutoff!: number;
  @Prop({ required: true, type: Number })
  private readonly maxWardCutoff!: number; // it will be updated later

  private numComponentsTickLabels: number[] = math.range(
    this.minNumComponents, this.maxNumComponents, 1, true)
    .toArray() as number[];

  private isNumberChanged: boolean = false; // to prevent redundant re-drawing
  private isCutoffChanged: boolean = false; // to prevent redundant re-drawing

  private forceNumberSliderDisabled: boolean = false;
  private forceCutoffSliderDisabled: boolean = false;

  private mounted() {
    eventBus.$on('handleNumberSliderEventEnd', () => {
      this.isNumberChanged = false;
    });
    eventBus.$on('handleCutoffSliderEventEnd', () => {
      this.isCutoffChanged = false;
    });
  }

  private numberSliderDisabled() {
    return this.forceNumberSliderDisabled;
  }
  private cutoffSliderDisabled() {
    return this.forceCutoffSliderDisabled;
  }

  private async handleNumberSliderEvent(arg: number | Event) {
    if (Number.isInteger(arg as number)) { // handle v-on:input
      this.$emit('numComponentsChanged', arg);
      this.isNumberChanged = true;
    } else {
      switch ((arg as Event).type) {
        case 'mousedown': // hande v-on:mousedown
          this.forceCutoffSliderDisabled = true;
          break;
        case 'click': // hande v-on:click
          this.forceCutoffSliderDisabled = false;
          if (!this.isNumberChanged) { return; }
          this.$emit('handleNumberSliderEvent');
          break;
      }
    }
  }

  private async handleCutoffSliderEvent(arg: Event | number) {
    if (Number.isFinite(arg as number)) { // handle v-on:input
      this.$emit('wardCutoffChanged', arg);
      this.isCutoffChanged = true;
    } else {
      switch ((arg as Event).type) {
        case 'mousedown': // hande v-on:mousedown
          this.forceNumberSliderDisabled = true;
          break;
        case 'click': // hande v-on:click
          this.forceNumberSliderDisabled = false;
          if (!this.isCutoffChanged) { return; }
          this.$emit('handleCutoffSliderEvent');
          break;
      }
    }
  }

  private async clickNumberOfInitialComponentsRadio(value: number) {
    this.$emit('numComponentsChanged', value);
    this.$emit('numberOfInitialComponentsRadioChanged');
  }
}
